<template>
  <nuxt-link
    :to="to"
    class="pdf-thumbnail"
    :alt="title"
    @click.capture="handleClickPath"
  >
    <h5 class="title">
      <Icon
        v-if="isTrialItem"
        size="2rem"
        name="fluent-emoji-flat:wrapped-gift"
      />
      {{ title }}
    </h5>
    <div class="img-wrapper">
      <img :src="imgSrc" />
    </div>
  </nuxt-link>
</template>
<script lang="ts" setup>
type Props = {
  contentId: string;
  type?: 'essential' | 'annals';
  title: string;
  imgSrc: string;
  to: string;
};
const props = defineProps({
  contentId: null,
  type: null,
  title: null,
  imgSrc: null,
  to: null
});

const { handleClickPath, isTrialItem } = useCategoryContentClick(
  {
    lockedContent: props.type,
    id: props.contentId,
  },
  props.to
);
</script>
<style lang="scss" scoped>
button {
  min-width: 0;
}
.title {
  position: relative;
  z-index: 1;
  width: 100%;
  overflow: hidden;
  transition: color 300ms $ease-out-quad;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 40%;
    width: 20%;
    height: 0.1rem;
    transform: scale(0);
    transition: transform 300ms $ease-out-quad;
    background: var(--color_secondary);
  }
}
.img-wrapper {
  width: 100%;
  aspect-ratio: 198/ 280;
  background: var(--color_neutral_100);
}
img {
  position: relative;
  z-index: 1;
  width: 100%;
  height: auto;
  transform-origin: 50%;
  transition: filter 300ms $ease-out-quad, transform 300ms $ease-out-quad;
  filter: grayscale(0%);
}
.pdf-thumbnail {
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  overflow: visible;
  gap: var(--gap_n);

  &:focus,
  &:hover {
    .title {
      color: var(--color_secondary);
      &::after {
        transform: scale(1);
      }
    }
    img {
      filter: grayscale(100%);
      transform: scale(0.98);
    }
  }
}
</style>
